import { render } from "./LearnSingle.vue?vue&type=template&id=555afd54&scoped=true"
import script from "./LearnSingle.vue?vue&type=script&lang=js"
export * from "./LearnSingle.vue?vue&type=script&lang=js"

import "./LearnSingle.vue?vue&type=style&index=0&id=555afd54&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555afd54"]])

export default __exports__